export enum E_ThemeOption {
  Light= 'light',
  Dark = 'dark',
  System = 'system',
}
